"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { LEGAL_CONSENT_FIELD } from "@/lib/legal-consent";

export function FormLegalConsent({
  id = "legal-consent",
}: {
  id?: string;
}) {
  const t = useTranslations("FormConsent");
  const linkClassName =
    "cursor-pointer font-medium text-(--mk-gold-light) underline-offset-2 hover:underline";

  return (
    <div className="flex items-start gap-3">
      <input
        id={id}
        name={LEGAL_CONSENT_FIELD}
        type="checkbox"
        value="on"
        aria-required="true"
        className="mt-1 h-4 w-4 shrink-0 cursor-pointer accent-(--mk-gold) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--mk-gold)"
      />
      <label
        htmlFor={id}
        className="cursor-pointer text-sm leading-relaxed text-(--mk-cream-75)"
      >
        {t.rich("label", {
          privacy: (chunks) => (
            <Link href="/privacy" className={linkClassName}>
              {chunks}
            </Link>
          ),
          terms: (chunks) => (
            <Link href="/terms" className={linkClassName}>
              {chunks}
            </Link>
          ),
        })}
      </label>
    </div>
  );
}

export function AuthLegalNotice() {
  const t = useTranslations("FormConsent");
  const linkClassName =
    "cursor-pointer font-medium text-(--mk-gold-light) underline-offset-2 hover:underline";

  return (
    <p className="mt-4 text-center text-xs leading-relaxed text-(--mk-cream-75)">
      {t.rich("authNotice", {
        privacy: (chunks) => (
          <Link href="/privacy" className={linkClassName}>
            {chunks}
          </Link>
        ),
        terms: (chunks) => (
          <Link href="/terms" className={linkClassName}>
            {chunks}
          </Link>
        ),
      })}
    </p>
  );
}
